





































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { SkillModel } from '@/model/charactersheets';
interface Skill {
  label: string;
  initial: number;
  keywords: string[];
}

@Component
export default class Presentational extends Vue {
  public searchWord: string = '';
  public searchedList: Skill[] = this.skills;

  @Prop() public skillList!: Skill[];

  @Emit() public update(skill: SkillModel) {}
  @Emit() public close() {}

  private get skills() {
    return this.skillList;
  }

  public add(payloadLabel: string, payloadInitial: number) {
    this.update({
      label: payloadLabel,
      initial: payloadInitial,
      interestpoint: 0,
      jobpoint: 0,
      otherpoint: 0,
      totalpoint: payloadInitial,
    });
    this.close();
  }

  public search(payload: string) {
    const searched = this.skills.filter(skill => {
      return skill.keywords.some(keyword => {
        return keyword.startsWith(payload);
      });
    })!;
    this.searchedList = [];

    if (!payload) {
      this.searchedList = this.skills;
    }

    if (searched) {
      this.searchedList = [...this.searchedList, ...searched];
    } else {
      this.searchedList = [];
    }
  }
}
